export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  DASHBOARD_LLM: '/dashboard/llm',
  DASHBOARD_FEED: '/dashboard/feed',
  DASHBOARD_ACTIVITIES: '/dashboard/my-activities',
  EXPLORE: '/dashboard/explore',
  NOTIFICATIONS: '/dashboard/notifications',
  PROFILE: '/dashboard/profile',
  SETTINGS: '/dashboard/settings',
  ACTIVITY: '/dashboard/activity',
  PUBLIC_ACTIVITY: '/activity',
  WIZARD: '/wizard'
}; 